export const splitPath = (path: string) => path.split('/').slice(1);
